import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Section from '../../../enums/Sections';
import Button from '../../../UI/Button/Button';
import RenderOn from '../../../UI/RenderOn/RenderOn';
import {stepBackwards} from '../../../v2/actions/uiActions';
import Translation from '../../../v2/lang/Translation';
import getPage from '../../../v2/page/getPage';
import {
  getIsRedesignPhase1BExperimentCTAVariant,
  isCollapsibleExperiment,
} from '../../../v2/selectors/ExperimentSelectors';
import isLastStep from '../../../v2/selectors/isLastStepSelector';
import {isInApp} from '../../../v2/utils/user-agent';
import ProgressButtonContainer from './ProgressButtonContainer';

export function BackButton(props) {
  const handleClick = () => {
    if (props.isApp) {
      // issue with webview android and back button
      props.stepBackwards();
    } else {
      window.history.back();
    }
  };
  
  const backButton = (
    <Button
      id={`ProgressButtons${props.currentButtonLocation}__backButton`}
      data-test="ProgressButtons__backButton"
      onClick={handleClick}
    >
      <Translation>{props.backwardLabel}</Translation>
    </Button>
  );
  
  return !props.hidden && (
    <RenderOn mobile>
      <ProgressButtonContainer fullWidth={!props.isLastStep} background={props.isLastStep}>
        {backButton}
      </ProgressButtonContainer>
    </RenderOn>
  );
}

BackButton.propTypes = {
  hidden: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  currentButtonLocation: PropTypes.string.isRequired,
  backwardLabel: PropTypes.string.isRequired,
  stepBackwards: PropTypes.func,
  isApp: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const currentStep = state.ui.checkoutProgressStep;
  const currentSectionIndex = currentStep - 1;
  
  const backwardLabels = {
    [Section.ADDRESS]: 'btn.back.address',
    [Section.DELIVERY]: 'btn.back.delivery',
  };
  
  const isCTAExperiment = getIsRedesignPhase1BExperimentCTAVariant(state);
  
  return {
    currentButtonLocation: `__${getPage()}_step${currentStep}`.toLowerCase(),
    backwardLabel: (isCTAExperiment && backwardLabels[state.ui.sections[currentSectionIndex - 1]]) || 'btn.back.text',
    isLastStep: isLastStep(state),
    hidden: currentStep === 1 || isCollapsibleExperiment(state),
    isApp: !!isInApp(state),
  };
};

export default connect(mapStateToProps, {stepBackwards})(BackButton);
